<template>
  <div
    v-if="blok && blok.slides && blok.slides.length"
    v-editable="blok"
    :class="marginClasses"
    class="my-2"
  >
    <h2
      class="mb-4 text-center text-xl leading-8 md:mb-6 md:text-2xl md:leading-9"
    >
      {{ blok.headline }}
    </h2>
    <BasicSlider
      :max-items-per-slide="5"
      :items="blok.slides"
      key-prop="_uid"
      @slide-visible="visibilityHandler"
    >
      <template #item="{ item, index }">
        <IconSliderSlide
          :blok="item"
          @click:icon-slide="trackSliderSlideClick($event, index)"
        />
      </template>
    </BasicSlider>
  </div>
</template>

<script setup lang="ts">
import type {
  SbIconSlider,
  SbIconSliderSlide,
} from '~/cms/storyblok/types/storyblok.d.ts'

const props = defineProps({
  blok: {
    type: Object as PropType<SbIconSlider>,
    default: () => {},
  },
})
const { marginClasses } = useStoryblokMargins(props.blok)
const { trackPromotion, trackPromotionForMultipleItems } = useTrackingEvents()
const { toLocalePath } = useRouteHelpers()

const trackingCollector = ref<SbIconSliderSlide[]>([])

const trackSliderSlideClick = (blok: SbIconSliderSlide, index: number) => {
  trackPromotion(
    'select_promotion',
    {
      promotion_name: 'slider_top_categories',
      location_id: blok.location_id || blok.label || '',
      promotion_id: `${index + 1}`,
      creative_slot: props.blok.creative_slot || '',
      creative_name: props.blok.creative_name || '',
    },
    { url: toLocalePath(blok?.labelLink?.cached_url || '').toString() },
  )
}

const visibilityHandler = (visibleItems: SbIconSliderSlide[], index: number) => {
  const untrackedItems = visibleItems?.filter(
    (item) => !trackingCollector.value.includes(item),
  )

  if (untrackedItems.length === 0) return

  trackPromotionForMultipleItems(
    'view_promotion',
    untrackedItems?.map((slide) => ({
      promotion_name: 'slider_top_categories',
      location_id: slide.label,
      promotion_id: `${index + 1}`,
      creative_slot: props.blok.creative_slot,
      creative_name: props.blok.creative_name,
    })),
    { url: toLocalePath(visibleItems[0]?.labelLink?.cached_url || '').toString() },
  )

  trackingCollector.value.push(...untrackedItems)
}
</script>
